export const DEFAULT_SIDEPANEL_SECTION_ORDER = ['upcoming', 'reminders', 'actions', 'history'] as const

export type SidepanelSectionKey = (typeof DEFAULT_SIDEPANEL_SECTION_ORDER)[number]

const KNOWN_SIDEPANEL_SECTION_KEYS = new Set<string>(DEFAULT_SIDEPANEL_SECTION_ORDER)

export const isSidepanelSectionKey = (key: unknown): key is SidepanelSectionKey => {
  return typeof key === 'string' && KNOWN_SIDEPANEL_SECTION_KEYS.has(key)
}

// Nothing here special-cases the previous default order (upcoming, actions,
// reminders, history). Order is only persisted on a drop, so a user who never
// reordered has no stored value at all and picks up the new default for free —
// while a stored value equal to the old default is a real customization. A
// migration keyed on the sequence can't tell those apart, and would make the
// old default the one arrangement the user can never drag back to.
export const sanitizeSidepanelSectionOrder = (order: unknown): Array<SidepanelSectionKey> => {
  const seen = new Set<SidepanelSectionKey>()
  const result: Array<SidepanelSectionKey> = []
  const persistedOrder: Array<unknown> = Array.isArray(order) ? order : []

  for (const key of persistedOrder) {
    if (isSidepanelSectionKey(key) && !seen.has(key)) {
      seen.add(key)
      result.push(key)
    }
  }

  for (const key of DEFAULT_SIDEPANEL_SECTION_ORDER) {
    if (!seen.has(key)) {
      result.push(key)
    }
  }

  return result
}
